import script from "./callHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./callHistory.vue?vue&type=script&lang=ts&setup=true"

import "./callHistory.vue?vue&type=style&index=0&id=6d91ffdb&lang=css"

const __exports__ = script;

export default __exports__